import http from "./http-common";
import FaqModel from "../models/faq";

// Navbar APIs
// eslint-disable-next-line
export default new (class FaqService {
  // Get all members
  async getFaq() {
    return await http
      .get("/faqs?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((faq) => FaqModel.get(faq))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
